<div class="component-container">
    <div class="comments-section-container">
        <img src="/assets/images/icons/quote.svg" alt="quote" />
        <div class="font-mont-regular">
            They helped us very fast and efficiently... It is very hard to build business relationships right now in
            these times but Clicklease is trying to help businesses build back. We appreciate the support.
        </div>
        <div class="font-mont-regular">
            -KRISTEN RICHARD
        </div>
    </div>
    <div class="need-help-container">
        <h1 class="font-mont-semi-bold">Need Help? Have Questions?</h1>
        <div class="font-mont-regular">
            Call <span class="font-mont-regular">1-888-509-5592</span>
        </div>
    </div>
</div>